export default "__VITE_ASSET__DYqTzDFy__"